<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBA Claim</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> / <b>Claims</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- New -->
        <div></div>
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              New
              <span class="badge badge-pill badge-danger" v-if="new_claims.length !== 0">{{ new_claims.length }}</span>
            </h4>
            <p>The table below shows the list of new claims.</p>
            <div class="table-responsive">
              <table id="new_claim_tbl" class="display table table-striped table-bordered"
                style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Notification Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in new_claims" :key="index"
                    :style="{ color: getIncidentColor(claim.deadline_date) }">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_ic)"
                        :style="{ color: getIncidentColor(claim.deadline_date) }">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(claim.product_id)"
                        :style="{ color: getIncidentColor(claim.deadline_date) }">
                        {{ claim.product_name }}
                      </router-link>
                    </td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.notification_date
                        | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>
                      <router-link :to="claimDetail(claim.claim_id)" type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;">View Details</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- In Process -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">In Process</h4>
            <p>The table below shows the list of in process claims.</p>
            <div class="table-responsive">
              <table id="inprocess_claim_tbl" class="display table table-striped table-bordered"
                style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Date submit to counter</th>
                    <th>Notification Date</th>
                    <th>Deadline Date</th>
                    <th>Officer</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in inprocess_claims" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_ic)">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(claim.product_id)">
                        {{ claim.product_name }}
                      </router-link>
                    </td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.counter_date | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>
                      {{
                        claim.notification_date
                        | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ claim.deadline_date | moment("Do MMMM YYYY") }}</td>
                    <td>{{ claim.officer_name }}</td>
                    <td>
                      <router-link :to="claimDetail(claim.claim_id)" type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;">View Details</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- Completed -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Completed</h4>
            <p>The table below shows the list of completed claims.</p>
            <div class="table-responsive">
              <table id="completed_claim_tbl" class="display table table-striped table-bordered"
                style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Notification Date</th>
                    <th>Deadline Date</th>
                    <th>Officer</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in completed_claims" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_ic)">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(claim.product_id)">
                        {{ claim.product_name }}
                      </router-link>
                    </td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.notification_date
                        | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ claim.deadline_date | moment("Do MMMM YYYY") }}</td>
                    <td>{{ claim.officer_name }}</td>
                    <td>Completed</td>
                    <td>
                      <router-link :to="claimDetail(claim.claim_id)" type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;">View Details</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- Rejected -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Rejected</h4>
            <p>The table below shows the list of rejected claims.</p>
            <div class="table-responsive">
              <table id="rejected_claim_tbl" class="display table table-striped table-bordered"
                style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <!-- <th>Certificate No</th> -->
                    <th>Product</th>
                    <th>Type</th>
                    <th>Notification Date</th>
                    <th>Deadline Date</th>
                    <th>Officer</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in rejected_claims" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_ic)">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <!-- <td>
                    <router-link :to = "purchaseDetail(claim.detail_id)">
                      {{claim.cert_no}}
                    </router-link>
                  </td> -->
                    <td>{{ claim.product_name }}</td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.notification_date
                        | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ claim.deadline_date | moment("Do MMMM YYYY") }}</td>
                    <td>{{ claim.officer_name }}</td>
                    <td>Rejected</td>
                    <td>
                      <router-link :to="claimDetail(claim.claim_id)" type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;">View Details</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- Just Report -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Reported Only</h4>
            <p>The table below shows the list of reported only claims.</p>
            <div class="table-responsive">
              <table id="report_only_claim_tbl" class="display table table-striped table-bordered"
                style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <!-- <th>Certificate No</th> -->
                    <th>Product</th>
                    <th>Type</th>
                    <th>Notification Date</th>
                    <th>Deadline Date</th>
                    <th>Officer</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in reported_only_claims" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_ic)">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <!-- <td>
                    <router-link :to = "purchaseDetail(claim.detail_id)">
                      {{claim.cert_no}}
                    </router-link>
                  </td> -->
                    <td>{{ claim.product_name }}</td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.notification_date
                        | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ claim.deadline_date | moment("Do MMMM YYYY") }}</td>
                    <td>{{ claim.officer_name }}</td>
                    <td>Report Only</td>
                    <td>
                      <router-link :to="claimDetail(claim.claim_id)" type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;">View Details</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- Void Claim -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Voided Claim</h4>
            <p>The table below shows the list of voided claims.</p>
            <div class="table-responsive">
              <table id="voided_claim_tbl" class="display table table-striped table-bordered"
                style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <!-- <th>Certificate No</th> -->
                    <th>Product</th>
                    <th>Type</th>
                    <th>Notification Date</th>
                    <th>Deadline Date</th>
                    <th>Status</th>
                    <th>Void By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in voided_claims" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(claim.customer_id)">
                        {{ claim.customer_name }}
                      </router-link>
                    </td>
                    <!-- <td>
                    <router-link :to = "purchaseDetail(claim.detail_id)">
                      {{claim.cert_no}}
                    </router-link>
                  </td> -->
                    <td>{{ claim.product_name }}</td>
                    <td>{{ claim.type }}</td>
                    <td>
                      {{
                        claim.notification_date
                        | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ claim.deadline_date | moment("Do MMMM YYYY") }}</td>
                    <td>Claim Void</td>
                    <td>{{ claim.void_by }}</td>
                    <td>
                      <router-link :to="claimDetail(claim.claim_id)" type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;">View Details</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import {
  getApproveClaim,
  markAsPaid,
  updatePaymentDate
} from "../../services/ClaimService";
import moment from "moment";
export default {
  name: "tba_claim",
  components: {},
  data() {
    return {
      new_claims: [],
      inprocess_claims: [],
      completed_claims: [],
      rejected_claims: [],
      reported_only_claims: [],
      voided_claims: [],
      approved_claims: [],
      pending_approved_claims: [],
      submitted_approved_claims: [],
      paid_approved_claims: [],
      all_approved_claims: [],
      editData: null,
      paymentMethod: "Bank Transfer",
      isOpenModal: false,
      buttons: [
        { status: true, name: "All" },
        { status: false, name: "Pending" },
        { status: false, name: "Submitted" },
        { status: false, name: "Paid" },
        { status: false, name: "Expired" }
      ],
      selectedItems: [],
      selectAll: false,
      selectedOption: 0,
      isMarkAsPaid: false,
      activeApprovedStatus: "",
      datatable: null
    };
  },

  watch: {
    selectAll(newVal, oldVal) {
      if (newVal) {
        // Select all items
        this.selectedItems = this.all_approved_claims
          .filter(claim => this.isSubmitted(claim))
          .map(claim => claim.id);
      } else {
        // Deselect all items
        this.selectedItems = [];
      }
    }
  },

  methods: {
    loadClaims() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/tba/claim", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.new_claims = res.data.new;
            this.inprocess_claims = res.data.inprocess;
            this.completed_claims = res.data.completed;
            this.rejected_claims = res.data.rejected;
            this.reported_only_claims = res.data.reported;
            this.voided_claims = res.data.claim_void;

            this.destroyDatatable();
          })
          .then(function () {
            $("#new_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                }
              ]
            });
            $("#inprocess_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                }
              ]
            });
            $("#completed_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                }
              ]
            });
            $("#rejected_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                }
              ]
            });
            $("#report_only_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                }
              ]
            });
            $("#voided_claim_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7]
                  }
                }
              ]
            });
          });
      }
    },

    async fetchApproveClaim() {
      try {
        const response = await getApproveClaim();

        if (response.data.success) {
          const { paid, pendings, submitted } = response.data.data;
          this.pending_approved_claims = pendings || [];
          this.paid_approved_claims = paid || [];
          this.submitted_approved_claims = submitted || [];
          this.all_approved_claims = [...(pendings || []), ...(paid || []), ...(submitted || [])];
          this.approved_claims = this.all_approved_claims;

          this.initializeApprovedClaimsDatatable();
        }
      } catch (error) {
        console.error(error);
      }
    },

    initializeApprovedClaimsDatatable() {
      if (this.datatable) {
        this.datatable.destroy();
      }

      // Initialize new datatable
      this.$nextTick(() => {
        this.datatable = $('#approved_claim_tbl').DataTable({
          pageLength: 5,
          dom: "Bfrtip",
          buttons: [
            {
              extend: "excelHtml5",
              exportOptions: {
                columns: [0, 1, 2, 3, 4, 5, 6]
              }
            },
            {
              extend: "pdfHtml5",
              exportOptions: {
                columns: [0, 1, 2, 3, 4, 5, 6]
              }
            }
          ]
        });
      });
    },

    isSubmitted(claim) {
      return claim.status === "Submitted";
    },

    filterApprovedClaims(status) {
      this.activeApprovedStatus = status;
      this.selectedItems = [];
      this.selectAll = false;

      if ($.fn.DataTable.isDataTable("#approved_claim_tbl")) {
        $("#approved_claim_tbl").DataTable().destroy();
      }

      // Update claims based on status
      switch (status) {
        case "":
          this.approved_claims = this.all_approved_claims;
          break;
        case "Pending":
          this.approved_claims = this.pending_approved_claims;
          break;
        case "Submitted":
          this.approved_claims = this.submitted_approved_claims;
          break;
        case "Paid":
          this.approved_claims = this.paid_approved_claims;
          break;
        default:
      }

      setTimeout(() => {
        $("#approved_claim_tbl").DataTable({
          pageLength: 5,
          dom: "Bfrtip",
          buttons: [
            {
              extend: "excelHtml5",
              exportOptions: {
                columns: columns,
              },
            },
            {
              extend: "pdfHtml5",
              exportOptions: {
                columns: columns,
              },
            },
          ],
        });
      }, 100); // Slight delay to ensure DOM updates are reflected
    },

    initializeDatatable(selector, columns) {
      $(selector).DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: columns
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: columns
            }
          }
        ]
      });
    },

    destroyDatatable() {
      const tables = [
        "#inprocess_claim_tbl",
        "#new_claim_tbl",
        "#completed_claim_tbl",
        "#rejected_claim_tbl",
        "#report_only_claim_tbl",
        "#voided_claim_tbl"
      ];
      tables.forEach(table => {
        if ($.fn.DataTable.isDataTable(table)) {
          $(table).DataTable().destroy();
        }
      });
    },

    loadAllData() {
      this.loadClaims();
    },

    claimDetail(id) {
      return "/tba/claim_details/" + id;
    },

    purchaseDetail(id) {
      return "/tba/details/" + id;
    },

    customerPage(ic_number) {
      return "/customer/" + ic_number;
    },

    productPage(id) {
      return "/marketing/product/detail/" + id;
    },

    openPaymentDateModal(claim) {
      this.isMarkAsPaid = false;
      this.isOpenModal = true;
      this.editData = claim;
    },

    openMarkAsPaidModal() {
      this.isMarkAsPaid = true;
      this.isOpenModal = true;
    },

    async handleMarkAsPaid() {
      if (this.selectedItems.length < 1) {
        this.isOpenModal = false;

        return swal({
          icon: "error",
          title: "Error",
          text: "Please tick one of the box."
        });
      }

      const request = {
        claim_payment_ids: this.selectedItems,
        payment_date: this.datePaid
      };

      try {
        const response = await markAsPaid(request);
        if (response.data.success) {
          swal({
            icon: "success",
            text: response.data.message
          });
        }
        this.fetchApproveClaim();
        this.isOpenModal = false;
        this.datePaid = null;
        this.isMarkAsPaid = false;
      } catch (error) {
        console.error(error);
      }
    },

    async addDate() {
      try {
        const request = {
          payment_date: this.datePaid
        };
        const response = await updatePaymentDate(request, this.editData.id);
        if (response.data.success) {
          swal({
            icon: "success",
            text: response.data.message
          });
          this.datePaid = null;
          this.editData = null;
          this.isOpenModal = false;
          this.fetchApproveClaim();
        }
      } catch (error) {
        console.error(error);
      }
    },

    handleSubmit() {
      if (this.isMarkAsPaid) {
        this.handleMarkAsPaid();
      } else {
        this.addDate();
      }
    },

    getIncidentColor(date) {
      if (!date) return 'black';
      return !moment(date).isSameOrAfter(moment(), 'day') ? '#c085fb !important' : '';
    },
  },

  mounted() {
    this.loadAllData();
    this.fetchApproveClaim();
  },

  beforeDestroy() {
    // Clean up datatable
    if (this.datatable) {
      this.datatable.destroy();
    }
  }
};
</script>
